import type {FC} from 'react';

import styled from 'styled-components';

import type {WithDomStyleProp} from '../../utils/utility-types';
import type {Props, StyledProps} from './types';

import MinusSVG from '../../assets/icons/minus.svg';
import CheckSVG from './assets/check.svg';
import {useController} from './controller';
import {checkedIcon, indeterminateIcon, web} from './styles';
import {CheckboxV2} from './v2/Checkbox.v2';

const StyledCheckbox = styled.div<StyledProps>`
  ${web}
`;

const StyledCheckedIcon = styled(CheckSVG)<StyledProps>`
  ${checkedIcon}
`;

const StyledIndeterminateIcon = styled(MinusSVG)<StyledProps>`
  ${indeterminateIcon}
`;

const CheckboxV1: FC<WithDomStyleProp<Props>> = ({
  checked: checkedProp,
  disabled,
  indeterminate,
  onClick,
  testID,
  variant = 'default',
  ...rest
}) => {
  const {checked, clickHandler} = useController({
    checked: checkedProp,
    disabled,
    onClick,
    variant,
    ...rest,
  });

  return (
    <StyledCheckbox
      checked={checked}
      data-test-id={testID}
      disabled={disabled}
      indeterminate={indeterminate}
      onClick={clickHandler}
      variant={variant}
      {...rest}
    >
      {variant === 'default' && checked && !indeterminate ? (
        <StyledCheckedIcon size={rest.size} />
      ) : null}
      {variant === 'default' && indeterminate ? (
        <StyledIndeterminateIcon size={rest.size} />
      ) : null}
      {variant === 'circle' && indeterminate ? (
        <StyledIndeterminateIcon size={rest.size} />
      ) : null}
    </StyledCheckbox>
  );
};

const Checkbox: typeof CheckboxV1 & {
  V2: typeof CheckboxV2;
} = Object.assign(CheckboxV1, {V2: CheckboxV2});

export {Checkbox};
